export default __webpack_public_path__ + "static/media/bi_logo_black.9229ef8b.png";